const DEFAULT_BODY_FONT_SIZE = 17.6; // default font size

export function webviewFixer(): void {
	const bodyFontSize = parseFloat(window.getComputedStyle(document.body, null).getPropertyValue("font-size"));
	const calcValue = bodyFontSize / DEFAULT_BODY_FONT_SIZE;

	if (calcValue > 1) {
		document.querySelector("html").style.fontSize = `${bodyFontSize / (calcValue * calcValue)}px`;

		// form-control height fix:
		if (document.querySelector(".form-control") !== null) {
			const head = document.head || document.getElementsByTagName("head")[0];
			const style = document.createElement("style");
			head.appendChild(style);
			style.type = "text/css";
			style.appendChild(document.createTextNode(`.form-control { height: auto;}`));
		}
	}
}
